import { memo, useEffect, useState } from 'react'
import LazyLoad from 'react-lazyload'

import Ad from '@/components/Ad/Ad'
import { useAds } from '@/contexts/ads'

import styles from './Leaderboard.module.scss'

const rollAdId = (country?: string) => {
  const randomRoll = Math.random()
  const randomRollTwo = Math.random()
  const randomRollThree = Math.random()

  if (randomRollThree < 1) return 'SCM_INTERNAL'
  // Non-US users have a 50% chance to see TCGPlayer International ad
  // The remaining 50% receives the normal ad setup
  else if (country !== 'US' && randomRollTwo > 0.5) {
    return 'tcgplayerIntl'
  } else {
    /* Ad Setup:
     - 20% Card Kingdom Buylist

     - Half of remainder split between SCM
     - Other half of remainder goes to EDHREC Patreon
  */
    if (randomRoll === 0) return null
    else if (randomRoll < 0.2) return 'ckBuylist'
    else if (randomRoll < 0.2 + 0.8 * (1 / 12)) return 'archidekt'
    else if (randomRoll < 0.2 + 0.8 * (2 / 12)) return 'crossword'
    else if (randomRoll < 0.2 + 0.8 * (3 / 12)) return 'cs'
    else if (randomRoll < 0.2 + 0.8 * (4 / 12)) return 'csb'
    else if (randomRoll < 0.2 + 0.8 * (5 / 12)) return 'edhrecap'
    else if (randomRoll < 0.2 + 0.8 * (5.25 / 12)) return 'spellifyDark1'
    else if (randomRoll < 0.2 + 0.8 * (5.5 / 12)) return 'spellifyDark2'
    else if (randomRoll < 0.2 + 0.8 * (5.75 / 12)) return 'spellifyLight1'
    else if (randomRoll < 0.2 + 0.8 * (6 / 12)) return 'spellifyLight2'
    else if (randomRoll < 0.2 + 0.8 * (6 / 12 + 1 / 8)) return 'edhrecPatreon'
    else if (randomRoll < 0.2 + 0.8 * (6 / 12 + 2 / 8)) return 'edhrecPatreon201'
    else if (randomRoll < 0.2 + 0.8 * (6 / 12 + 3 / 8)) return 'edhrecPatreon202'
    else return 'edhrecPatreon203'
  }
}

type Props = {
  country?: string
}

const Leaderboard = ({ country }: Props) => {
  const { loadAds } = useAds()
  const [adId, setAdId] = useState<string | null>(null)

  useEffect(() => {
    setAdId(rollAdId(country))
    console.log('Country: ', country)
  }, [country])

  if (loadAds === undefined) return <div className={styles.container} />

  return (
    <div className={styles.container}>
      {adId === 'SCM_INTERNAL' ? (
        <div className={styles.leaderboard} data-scm-slot='leaderboard' />
      ) : (
        <div className={styles.leaderboardz}>
          <LazyLoad>{adId && <Ad id={adId} unit='leaderboard' />}</LazyLoad>
        </div>
      )}
    </div>
  )
}

export default memo(Leaderboard)
